<template>
  <div>
    <van-nav-bar :title="barTitle" :left-text="leftText" @click-left="onClickLeft" />
    <van-form ref="form" @submit="save">
      <van-tabs v-model="active">
        <van-tab title="基础信息">
          <base-input v-model="form.consult_date" :required="true" label="咨询日期" disabled />
          <base-input v-model="form.consult_curr_date" :required="true" label="咨询属期" disabled />
          <base-input v-model="form.linkman" :required="true" label="联系人" />
          <base-input v-model="form.phone" :required="true" label="联系方式" />
          <base-cascader v-model="form.source" :options="sourceList" :required="true" label="信息来源" />
          <base-select v-model="form.status" :options="CONST.CONSULT_STATUS" :required="true" label="咨询状态" />
          <base-select v-model="form.is_important" :options="CONST.YES_NO" label="重点客户" />
          <base-input v-model="form.client_name" label="客户名称" />
          <base-select v-model="form.sex" :options="CONST.SEX" label="性别" />
          <base-select v-model="form.is_pri" :options="CONST.YES_NO" label="法人" />
          <base-textarea v-model="form.info" :maxlength="500" :required="true" label="咨询信息" />
          <base-search-select v-model="form.sys_client_name" label="签约客户" @change="onClientSelectChange" />
          <base-select v-model="form.product_type_id" :options="productTypeList" label="产品类型" @change="onProductTypeSelectedChange" />
          <base-select v-model="form.product_id" :options="form.productList" label="服务" placeholder="请先选择产品类型" />
          <base-input v-model="form.quote" label="报价" />
          <base-cascader v-model="form.dept_id" :options="deptList" :required="true" label="指定分公司" />
          <base-search-select v-model="form.sell_emp_name" :url="'/employee/dict'" label="指定销售人员" @change="onEmpSelectChange" />
        </van-tab>
        <van-tab title="其他信息">
          <base-input v-model="form.reg_address" label="注册地址" />
          <base-input v-model="form.busi_address" label="办公地址" />
          <base-input v-model="form.main_busi" label="主营业务" />
          <base-select v-model="form.is_imp_exp" :options="CONST.HAVE_STATUS" label="进出口业务" />
          <base-select v-model="form.busi_type_id" :options="busiTypeList" label="企业类型" />
          <base-select v-model="form.ind_id" :options="indList" label="所属行业" />
        </van-tab>
        <van-tab title="跟进信息">
          <van-row>
            <van-col offset="18" span="6" style="padding-top: 5px">
              <base-button type="primary" @click="addFollow">新增跟进记录</base-button>
            </van-col>
          </van-row>
          <van-row class="list-title">
            <van-col span="8">跟进日期</van-col>
            <van-col span="12">备注</van-col>
            <van-col span="4">操作</van-col>
          </van-row>
          <van-cell v-for="detail in form.details" :key="detail.id" class="list-tip" >
            <van-col span="8" style="text-align: center">
              <base-input :type="'date'" v-model="detail.follow_date" disabled />
            </van-col>
            <van-col span="12" style="text-align: center">
              <base-textarea v-model="detail.comment" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <van-icon name="cross" style="padding-top: 5px;" @click="delFollow(detail)" />
            </van-col>
          </van-cell>
        </van-tab>
      </van-tabs>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import { getSourceList } from '@/api/source'
import { getDictList } from '@/api/dict'
import { getProductList } from '@/api/product'
import { getDeptList } from '@/api/dept'
import { addConsult, modifyConsult, addConsultDetail,
  modifyConsultDetail, deleteConsultDetail } from '@/api/consult'
import Init from '@/components/base/init'
export default {
  name: 'ConsultEdit',
  components: { Init },
  data() {
    return {
      barTitle: '新增咨询',
      leftText: '',
      active: 0,
      data: [],
      currDate: '', // 当前日期
      // currentDate: '', // 当前属期
      sourceList: [],
      dictList: [], // 字典
      busiTypeList: [], // 企业类型
      indList: [], // 所属行业
      productTypeList: [], // 产品类型
      dictProductList: [], // 全产品
      detailsMap: [],
      deptList: [],

      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS
      },
      form: {
        consult_date: null,
        consult_curr_date: null,
        linkman: '',
        phone: '',
        source: null,
        status: null,
        is_important: 2,
        client_name: '',
        sex: 1,
        is_pri: 1,
        info: '',
        client_id: null,
        sys_client_name: '',
        product_type_id: null,
        product_id: null,
        productList: [],
        quote: '',
        dept_id: null,
        sell_emp_id: null,
        sell_emp_name: '',

        reg_address: '',
        busi_address: '',
        main_busi: '',
        is_imp_exp: 2,
        details: []
      },
      initStates: [{
        key: 'app/initCurrentDate'
      }]
    }
  },
  computed: {
    ...mapGetters(['currentDate', 'selectedConsult'])
  },
  mounted() {
    const now = new Date()
    this.currDate = this.Utils.df(now);
    this.query()
    this.init()
  },
  methods: {
    init() {
      this.resetForm()
      
      setTimeout(() => {
        this.form.consult_curr_date = this.$store.state.app.currentDate;
      }, 500);

      if (this.selectedConsult) {
        this.form.consult_curr_date = this.currentDate;
        this.barTitle = '修改咨询'
        this.leftText = '返回'
        if (!this.selectedConsult.details) {
          this.selectedConsult.details = []
        }
        const data = this._.cloneDeep(this.selectedConsult)
        data.details = data.details ? data.details : []
        data.details.forEach(item => {
          this.detailsMap[item.id] = item.comment
        })
        data.consult_date = data.consult_date.slice(0, 10)
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
          overlay: true
        })
        setTimeout(() => {
          this.form = data
          if (this.form.product_type_id > 0) {
            this.onProductTypeSelectedChange()
            this.form.product_id = this.selectedConsult.product_id
          }
          Toast.clear()
        }, 1000)
      }
    },
    onClientSelectChange(name, value) {
      if (value) {
        this.form.client_id = value.id
      }
    },
    onEmpSelectChange(name, value) {
      if (value) {
        this.form.sell_emp_id = value.id
      }
    },
    onProductTypeSelectedChange() {
      this.form.productList = []
      this.form.product_id = null
      if (this.form.product_type_id) {
        this.dictProductList.forEach(product => {
          if (this.form.product_type_id === product.type_id) {
            this.form.productList.push(product)
          }
        })
      } else {
        this.form.productList = []
      }
    },
    resetForm() {
      this.Utils.resetValue(this.form)
      this.form.consult_date = this.currDate
      this.form.source = null
      this.form.is_important = 2
      this.form.sex = 1
      this.form.is_pri = 1
      this.form.is_imp_exp = 2
    },
    query() {
      this.querySourceList()
      this.queryDictList()
      this.queryProductList()
      this.queryDeptList()
    },
    querySourceList() {
      getSourceList(this.queryCondition).then(resp => {
        this.sourceList = resp.rows || []
      })
    },
    queryDictList() {
      getDictList(this.queryCondition).then(resp => {
        this.dictList = resp.rows || []
        this.Utils.fillDictList(
          this.dictList,
          [2, 21, 23],
          [
            this.productTypeList,
            this.busiTypeList,
            this.indList
          ]
        )
      })
    },
    queryProductList() {
      getProductList(this.queryCondition).then(resp => {
        this.dictProductList = resp.rows || []
      })
    },
    queryDeptList() {
      getDeptList(this.queryCondition).then(resp => {
        this.deptList = resp.rows || []
      })
    },
    onClickLeft() {
      this.$router.push('/consult/manage')
    },
    addFollow() {
      this.form.details.push({
        follow_date: this.Utils.df(Date.now()),
        comment: ''
      })
    },
    saveFollow(type, postData) {
      if (type === 'modify') {
        modifyConsultDetail(postData).then(resp => {
          if (resp.success) {
            // this.success(resp.msg)
          }
        })
      } else if (type === 'add') {
        addConsultDetail(postData).then(resp => {
          if (resp.success) {
            // this.success(resp.msg)
          }
        })
      }
    },
    delFollow(follow) {
      if (follow.id) {
        Dialog.confirm({
          title: '提示',
          message: '确定删除跟进记录吗？'
        }).then(() => {
          deleteConsultDetail({
            id: parseInt(follow.id)
          }).then(resp => {
            if (resp.success) {
              const index = this.form.details.indexOf(follow)
              if (index !== -1) {
                this.form.details.splice(index, 1)
              }
              this.success(resp.msg)
            }
          })
        })
      } else {
        const index = this.form.details.indexOf(follow)
        if (index !== -1) {
          this.form.details.splice(index, 1)
        }
      }
    },
    saveModifyConsult() {
      modifyConsult(this.form).then(resp => {
        if (resp.success) {
          this.success(resp.msg);
          this.$router.push('/consult/manage');
        }
      });
    },
    save() {
      if (this.form.sys_client_name && !this.form.client_id) {
        this.toast('输入关键字后请在列表中选择签约客户')
        return
      }
      if (this.form.sell_emp_name && !this.form.sell_emp_id) {
        this.toast('输入关键字后请在列表中选择指定销售人员')
        return
      }
      if (this.form.status === 4 && !this.form.client_id) {
        this.toast('已成交的记录必须选择签约客户')
        return
      }
      if (this.form.id) {
        for (let i = 0; i < this.form.details.length; i++) {
          if (this.form.details[i].id > 0) {
            // 跟进记录有修改时，更新该条记录
            const key = this.form.details[i].id
            const beforeComment = this.detailsMap[key]
            const afterComment = this.form.details[i].comment
            const type = 'modify'
            const postData = {
              id: this.form.details[i].id,
              comment: afterComment
            }
            if (beforeComment !== afterComment) {
              this.saveFollow(type, postData)
            }
          } else if (!this.form.details[i].id) {
            // 新增跟进记录
            const type = 'add'
            const postData = {
              main_id: this.form.id,
              follow_date: this.form.details[i].follow_date,
              comment: this.form.details[i].comment
            }
            this.saveFollow(type, postData)
          }
        }
        this.saveModifyConsult()
      } else {
        addConsult(this.form).then(resp => {
          if (resp.success) {
            this.success(resp.msg)
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/consult/consult-edit.vue